export const types = {
  Adjustment: "Adjustment",
  Reception: "Reception",
  Transfer: "Transfer",
  Refund: "Refund",
  Void: "Void",
  Sale: "Sale",
};

export const translate = {
  Adjustment: "Ajuste",
  Reception: "Recepcion",
  Transfer: "Despacho",
  Refund: "Devolucion",
  Void: "Anulación",
  Sale: "Venta",
};

export const select = Object.keys(types)
  .map(type => ({ value: type, label: translate[type] }));

export default types;